export const toAUD = (str) =>
  str.toLocaleString('en-AU', { style: 'currency', currency: 'AUD', minimumFractionDigits: 0 });

export const titlise = (str) => str.charAt(0).toUpperCase() + str.slice(1);

export const camelToSnakeCase = (str) => str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
